module.exports = {
    expressPort: 8000,
    // siteUrl: process.env.REACT_APP_API_URL,
  // siteUrl: 'http://ementor2021.localhost.com:8888/api'
    siteUrl: 'https://ementor-new.potentialclasses.com/api'
    // siteUrl: 'http://ementor2021.com/api'
}

